import axios from "axios";
import history from "./history.js";

const http = axios.create({
    baseURL: 'https://e-tech.ie/api/'
    // baseURL: 'http://192.168.1.8:8000/',
});

http.interceptors.request.use((request) => {
    const token = window.localStorage.getItem("token");
    if (token) {
        request.headers.token = token;
    }
    return request;
});

http.interceptors.response.use((response) => {

    if (window.location.pathname !== "/login" && response.data?.code === 401) {
        window.localStorage.removeItem("token");
        if (response.data?.msg.endsWith("expired")) {
            window.location.reload();
        } else {
            history.replace("/login", {from: window.location.pathname});
        }
    }

    return response;
});

export default http;
